export const PUBLIC_SITE_ORIGIN = "https://duratarp.cn";

export function publicUrl(path = "/"): string {
  return `${PUBLIC_SITE_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
}
